import SearchAutocomplete from './SearchAutocomplete'
export default SearchAutocomplete
